export default {
    createdAt: 'נוצר בתאריך',
    createdBy: 'נוצר על ידי',
    canceled: 'בוטל ',
    canceledBy: 'בוטל ע״י',
    canceledAt: 'בוטל ב',
}
